import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from "@/components/ui/accordion";
import { MaskLines, Reveal } from "@/components/site/Reveal";

export const FAQS = [
  ["What areas do you service?", "We work across Sydney and surrounding suburbs. Call us or send a booking request and we'll confirm we can get to you."],
  ["Do you work with builders and developers?", "Yes. New builds are a core part of our work — we handle drainage, rough-in, hot water, gas and final fit-off and coordinate with your other trades."],
  ["Do you look after strata buildings?", "Yes. We work with strata managers, building managers and owners corporations on common-property and lot plumbing, with clear job reporting."],
  ["Can I book online?", "Yes. Use our booking page to pick a date and time window, or request a quote if you'd like us to price the job first. We'll contact you to confirm."],
  ["Do you take on commercial and industrial jobs?", "Absolutely — from shop fit-outs and amenities to large-bore pipework and site drainage for industrial facilities."],
];

export const Faq = () => (
  <section data-testid="faq-section" className="bg-porcelain py-24 sm:py-32">
    <div className="container-x grid gap-12 lg:grid-cols-12">
      <div className="lg:col-span-4">
        <Reveal><p className="eyebrow text-cobalt mb-5">FAQ</p></Reveal>
        <h2 className="font-wide font-black uppercase text-4xl sm:text-5xl leading-[0.95] tracking-tight">
          <MaskLines lines={["Good", "questions."]} />
        </h2>
      </div>
      <Reveal className="lg:col-span-8">
        <Accordion type="single" collapsible className="border-t border-ink/15">
          {FAQS.map(([q, a], i) => (
            <AccordionItem key={q} value={`q${i}`} className="border-ink/15">
              <AccordionTrigger data-testid={`faq-trigger-${i}`} className="font-wide font-bold text-lg sm:text-xl py-6 hover:no-underline hover:text-cobalt">{q}</AccordionTrigger>
              <AccordionContent className="text-slate-600 text-base leading-relaxed pr-8">{a}</AccordionContent>
            </AccordionItem>
          ))}
        </Accordion>
      </Reveal>
    </div>
  </section>
);
